import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { FaPlus, FaTrash } from "react-icons/fa";

import {
  useSaveQuizBlueprintMutation,
  useGetQuizBlueprintQuery,
} from "../../slices/quizApiSlice";

import { useGetQuizByIdQuery } from "../../slices/quizApiSlice";

import {useGetQuestionAvailabilityByChapterQuery, } from "../../slices/questionApiSlice";

import { useGetChaptersBySubjectQuery } from "../../slices/chapterApiSlice";

const emptySection = {
  name: "",
  chapter: "",
  difficulty: "medium",
  questionType: "mcq",
  numberOfQuestions: 5,
  marksPerQuestion: 1,
};

const QuestionAvailability = ({
  index,
  chapter,
  difficulty,
  setAvailability,
}) => {
  const { data, isFetching } = useGetQuestionAvailabilityByChapterQuery(
    {
      chapter,
      difficulty,
    },
    {
      skip: !chapter || !difficulty,
    },
  );

  useEffect(() => {
  if (data?.availableQuestions !== undefined) {
    setAvailability((prev) => ({
      ...prev,
      [index]: data.availableQuestions,
    }));
  }
}, [data, index, setAvailability]);

  if (!chapter) return null;

  return (
    <p className="mt-2 text-sm font-semibold text-blue-700">
  {isFetching
    ? "Checking availability..."
    : `Available Questions: ${data?.availableQuestions ?? 0}`}
</p>
  );
};

QuestionAvailability.propTypes = {
  index: PropTypes.number.isRequired,
  chapter: PropTypes.string,
  difficulty: PropTypes.string,
  setAvailability: PropTypes.func.isRequired,
};

const ChapterDropdown = ({ subjectId, value, onChange }) => {
  const { data, isLoading } = useGetChaptersBySubjectQuery(subjectId, {
    skip: !subjectId,
  });

  const chapters = data?.data || data || [];

  return (
    <select
      value={value}
      onChange={onChange}
      disabled={!subjectId || isLoading}
      className="rounded-lg border px-4 py-2"
    >
      <option value="">
        {!subjectId
          ? "Loading Subject..."
          : isLoading
            ? "Loading Chapters..."
            : "Select Chapter"}
      </option>

      {chapters.map((chapter) => (
        <option key={chapter._id} value={chapter._id}>
          {chapter.name}
        </option>
      ))}
    </select>
  );
};

ChapterDropdown.propTypes = {
  subjectId: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const QuizBlueprintForm = ({ quizId, mode = "create", onSuccess }) => {
  

  console.error("QUIZ ID FROM COMPONENT:", quizId);
  const [sections, setSections] = useState([{ ...emptySection }]);
  const [availability, setAvailability] = useState({});

  const [saveQuizBlueprint, { isLoading: saving }] =
    useSaveQuizBlueprintMutation();

  // Fetch quiz to obtain its subject
 const {
  data: quiz,
  isLoading: quizLoading,
  isError: quizError,
  error: quizErrorData,
} = useGetQuizByIdQuery(quizId, {
  skip: !quizId,
});


// useEffect(() => {
//   console.error("QUIZ LOADING:", quizLoading);
//   console.error("QUIZ DATA:", quiz);
//   console.error("QUIZ ERROR:", quizError);
//   console.error("QUIZ ERROR DATA:", quizErrorData);
// }, [
//   quiz,
//   quizLoading,
//   quizError,
//   quizErrorData,
// ]);


useEffect(() => {

  console.log("Quiz Loading:", quizLoading);

  console.log("Quiz Response:", quiz);

  console.log("Quiz Error:", quizError);

  console.log("Quiz Error Data:", quizErrorData);

}, [
  quiz,
  quizLoading,
  quizError,
  quizErrorData,
]);

  const subjectId =
  quiz?.questionBankSubject?._id || "";
  
  console.log("Subject ID:", subjectId);

const {
  data: blueprintResponse,
  isLoading: blueprintLoading,
} = useGetQuizBlueprintQuery(quizId, {
  skip: mode !== "edit",
});


useEffect(() => {
  if (mode !== "edit") return;

  const existingSections =
    blueprintResponse?.data?.sections ||
    blueprintResponse?.data?.blueprint ||
    [];

  console.log("Existing Blueprint Sections:", existingSections);

  if (existingSections.length > 0) {
    setSections(
      existingSections.map((item) => ({
        name: item.name || "",

        chapter:
          item.chapter?._id ||
          item.chapter ||
          "",

        difficulty:
          item.difficulty ||
          "medium",

        questionType:
          item.questionType ||
          "mcq",

        numberOfQuestions:
          Number(item.numberOfQuestions) || 1,

        marksPerQuestion:
          Number(item.marksPerQuestion) || 1,
      }))
    );
  }
}, [blueprintResponse, mode]);

  const updateSection = (index, field, value) => {
    const updated = [...sections];
    updated[index][field] = value;
    setSections(updated);
  };

  const addSection = () => {
    setSections((prev) => [...prev, { ...emptySection }]);
  };

  const removeSection = (index) => {
    if (sections.length === 1) return;

    setSections((prev) => prev.filter((_, i) => i !== index));
  };
  const submitHandler = async (e) => {
    e.preventDefault();

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const availableQuestions = availability[i] ?? 0;

      if (!section.name.trim()) {
        toast.error(`Section ${i + 1}: Please enter a section name`);
        return;
      }

      if (!section.chapter) {
        toast.error(`Section ${i + 1}: Please select a chapter`);
        return;
      }

      if (section.numberOfQuestions > availableQuestions) {
        toast.error(
          `Section ${i + 1}: Requested ${section.numberOfQuestions} questions, but only ${availableQuestions} available`,
        );
        return;
      }
    }

    try {
      await saveQuizBlueprint({
        quizId,
        blueprint: sections,
      }).unwrap();

      toast.success(
        mode === "edit"
          ? "Blueprint updated successfully"
          : "Blueprint created successfully",
      );

      onSuccess?.();
    } catch (error) {
      toast.error(
        error?.data?.message || error?.error || "Unable to save blueprint",
      );
    }
  };

  if (
  quizLoading ||
  (mode === "edit" && blueprintLoading && !blueprintResponse)
) {
  return (
    <div className="p-5 text-center">
      Loading blueprint...
    </div>
  );
}


if (quizError) {
  return (
    <div className="p-5 text-center text-red-600">
      Unable to load quiz
    </div>
  );
}

  return (
    <form
      onSubmit={submitHandler}
      className="space-y-6 rounded-3xl bg-white p-8 shadow-xl"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">
          {mode === "edit" ? "Edit Quiz Blueprint" : "Create Quiz Blueprint"}
        </h2>

        <button
          type="button"
          onClick={addSection}
          className="flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-white"
        >
          <FaPlus />
          Add Section
        </button>
      </div>

      {sections.map((section, index) => (
        <div key={index} className="space-y-4 rounded-xl border bg-gray-50 p-5">
          <div className="flex justify-between">
            <h3 className="font-semibold">Section {index + 1}</h3>

            <button
              type="button"
              onClick={() => removeSection(index)}
              className="text-red-600"
            >
              <FaTrash />
            </button>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            {/* Section Name */}

            <div>
              <label className="mb-1 block text-sm font-semibold">
                Section Name
              </label>

              <input
                type="text"
                value={section.name}
                onChange={(e) => updateSection(index, "name", e.target.value)}
                className="w-full rounded-lg border px-4 py-2"
                placeholder="Example: Algebra Easy"
              />
            </div>

            {/* Chapter */}

            <div>
              <label className="mb-1 block text-sm font-semibold">
                Chapter
              </label>
              <div>
                <label className="mb-1 block text-sm font-semibold">
                  Subject
                </label>

                <input
  type="text"
  value={
    quiz?.questionBankSubject?.name || ""
  }
  disabled
  className="w-full rounded-lg border bg-gray-100 px-4 py-2"
/>
              </div>

              <ChapterDropdown
                subjectId={subjectId}
                value={section.chapter}
                onChange={(e) =>
                  updateSection(index, "chapter", e.target.value)
                }
              />

              <QuestionAvailability
                index={index}
                chapter={section.chapter}
                difficulty={section.difficulty}
                setAvailability={setAvailability}
              />
            </div>

            {/* Difficulty */}

            <div>
              <label className="mb-1 block text-sm font-semibold">
                Difficulty
              </label>

              <select
                value={section.difficulty}
                onChange={(e) =>
                  updateSection(index, "difficulty", e.target.value)
                }
                className="w-full rounded-lg border px-4 py-2"
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </select>
            </div>

            {/* Question Type */}

            <div>
              <label className="mb-1 block text-sm font-semibold">
                Question Type
              </label>

              <select
                value={section.questionType}
                onChange={(e) =>
                  updateSection(index, "questionType", e.target.value)
                }
                className="w-full rounded-lg border px-4 py-2"
              >
                <option value="mcq">MCQ</option>
                <option value="true_false">True / False</option>
                <option value="multiple">Multiple Correct</option>
              </select>
            </div>

            {/* Number of Questions */}

            <div>
              <label className="mb-1 block text-sm font-semibold">
                Number of Questions
              </label>

              <input
                type="number"
                min="1"
                value={section.numberOfQuestions}
                onChange={(e) => {
                  const value = Number(e.target.value);

                  const maxAvailable = availability[index] ?? 0;

                  if (value > maxAvailable) {
                    toast.warning(
                      `Only ${maxAvailable} questions are available`,
                    );

                    return;
                  }

                  updateSection(index, "numberOfQuestions", value);
                }}
                className="w-full rounded-lg border px-4 py-2"
              />

              {availability[index] !== undefined &&
                section.numberOfQuestions > availability[index] && (
                  <p className="mt-1 text-sm text-red-600">
                    Question count cannot exceed available questions.
                  </p>
                )}
            </div>

            {/* Marks */}

            <div>
              <label className="mb-1 block text-sm font-semibold">
                Marks Per Question
              </label>

              <input
                type="number"
                min="1"
                value={section.marksPerQuestion}
                onChange={(e) =>
                  updateSection(
                    index,
                    "marksPerQuestion",
                    Number(e.target.value),
                  )
                }
                className="w-full rounded-lg border px-4 py-2"
              />
            </div>
          </div>
        </div>
      ))}

      <button
        disabled={saving}
        className="w-full rounded-xl bg-blue-600 py-3 font-semibold text-white disabled:opacity-50"
      >
        {saving
          ? "Saving..."
          : mode === "edit"
            ? "Update Blueprint"
            : "Create Blueprint"}
      </button>
    </form>
  );
};

QuizBlueprintForm.propTypes = {
  quizId: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(["create", "edit"]),
  onSuccess: PropTypes.func,
};

export default QuizBlueprintForm;
